<button [disabled]="disabled" *ngIf="isHidden !== true" mat-flat-button (click)="btnClicked.emit()" [ngClass]="disabled ? 'bg-gray-400' : 'bg-primary'"
  class=" btn btn-primary btn-xs md:btn-sm" type="button">
  <span *ngIf="faIcon" class="ml-2 text-xs text-white">
    <fa-icon [icon]="faIcon"></fa-icon>
  </span>
  {{ submitText }}
</button>